import React, {useContext} from 'react';
import {Props} from './Props';
import {css} from 'aphrodite';
import {colorBlindnessStyles, styles} from './styles';
import ThemeContext from '../../../../../../../../contexts/ThemeContext';
import {formatToStartedSinceMessage} from '../../../../../../../../utils/DateUtil';
import {enrichedDescription} from '../../../../../../../../services/SituationFeatureService';

const TrafficMessageRow: React.FunctionComponent<Props> = ({
    clickAvailable,
    highlight,
    situationFeature,
    onClickedOnSituationFeature,
}) => {
    const themeContext = useContext(ThemeContext);
    const startedSinceMessage = formatToStartedSinceMessage(situationFeature.properties.overallStartTime);

    return (
        <div
            className={css(
                styles.rowContainer,
                clickAvailable && styles.rowContainerClickAvailable,
                highlight && styles.highlightedRow,
                highlight &&
                    themeContext.currentColorSchemeIsSuitableForColorBlindness &&
                    colorBlindnessStyles.highlightedRow,
            )}
            onClick={() => onClickedOnSituationFeature()}
        >
            <div className={css(styles.titleRow)}>{situationFeature.properties.locationDescription}</div>
            { startedSinceMessage && (
                <div className={css(styles.timestamp)}>
                    {startedSinceMessage}
                </div>
            ) }
            <div className={css(styles.extraDetails)}>{enrichedDescription(situationFeature.properties)}</div>
        </div>
    );
};

export default TrafficMessageRow;
